import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button, Icons } from '@ohif/ui-next';
import { useAppConfig } from '@state';
import ErrorScreen from '../ErrorScreen';

const NotFound = ({ message, showGoBackButton = true }) => {
  const { t } = useTranslation('NotFound');
  const [appConfig] = useAppConfig();
  const { showStudyList } = appConfig;
  const navigate = useNavigate();

  const resolvedMessage = message ?? t("We can't find the page you're looking for.");

  return (
    <ErrorScreen
      illustration={<Icons.IllustrationNotFound />}
      title={t('Error (404)')}
    >
      <p>{resolvedMessage}</p>
      {showGoBackButton && showStudyList && (
        <Button
          className="mt-6 px-3 text-lg"
          onClick={() => navigate('/')}
        >
          {t('Return to Study List')}
        </Button>
      )}
    </ErrorScreen>
  );
};

NotFound.propTypes = {
  message: PropTypes.string,
  showGoBackButton: PropTypes.bool,
};

export default NotFound;
